import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Campaigns extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M19.8,11.9l-1.3-2.3c-1.1-2-2.3-4-3.4-5.9c-0.3-0.6-0.8-0.8-1.5-0.4c-1,0.6-1.9,1.1-2.9,1.7L3.4,9l-2.9,1.7
                    C0,11-0.2,11.5,0.2,12.1c1.6,2.8,3.2,5.6,4.9,8.4c0.3,0.6,0.9,0.7,1.4,0.4l5.2-3l7.8-4.5C20.1,13,20.1,12.4,19.8,11.9z M12.3,6.1
                    l-2.2,6l-6.4-1.1L12.3,6.1z M6.2,18.7l-3.4-5.8c0,0,6.2,1.1,7.7,1.3c0.3,0,0.5,0,0.7-0.1l0,0c0.2-0.1,0.4-0.3,0.5-0.6
                    c0.8-2.2,2.6-7.2,2.6-7.2l3.4,5.8L6.2,18.7z"
                />
                <path d="M23,19h-8c-0.5,0-1,0.4-1,1v0c0,0.5,0.4,1,1,1h8c0.5,0,1-0.4,1-1v0C24,19.4,23.6,19,23,19z" />
                <path d="M23,3h-4c-0.5,0-1,0.4-1,1v0c0,0.5,0.4,1,1,1h4c0.5,0,1-0.4,1-1v0C24,3.4,23.6,3,23,3z" />
                <path d="M23,7h-2c-0.5,0-1,0.4-1,1v0c0,0.5,0.4,1,1,1h2c0.5,0,1-0.4,1-1v0C24,7.4,23.6,7,23,7z" />
                <path d="M23,15h-2c-0.5,0-1,0.4-1,1v0c0,0.5,0.4,1,1,1h2c0.5,0,1-0.4,1-1v0C24,15.4,23.6,15,23,15z" />
                <path d="M23,11h-1c-0.5,0-1,0.4-1,1v0c0,0.5,0.4,1,1,1h1c0.5,0,1-0.4,1-1v0C24,11.4,23.6,11,23,11z" />
            </SvgIcon>
        );
    }
}

export default Campaigns;
